import React from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { useClassName } from 'common/hooks';
import { Loader } from 'common/lazy';
import { useEvents, useFeaturedEvents, useEventBlueprint } from './hooks';
import HeroSection from './components/HeroSection';
import HeroCarousel from './components/HeroCarousel';
import FeaturedEvents from './components/FeaturedEvents';
import GeneralEvents from './components/GeneralEvents';

import './adevents.less';

const AdEvents = (props) => {
  const className = useClassName('AdEventPage');

  const blueprint = useEventBlueprint(props.adEvents);
  const { events } = useEvents(props.adEvents);
  const { featuredEvents, heroFeaturedEvents, hasHeroFeatured } =
    useFeaturedEvents({
      blueprint,
      events,
    });

  const isLoading = events === null;
  const hasEvents = events?.length > 0;
  const hasFeaturedEvents = featuredEvents?.length > 0;

  return (
    <div className={className('container')}>
      {isLoading && (
        <div className={className('loader')}>
          <Loader inline="centered" active />
        </div>
      )}

      {!isLoading && !hasEvents && <span>No upcoming events</span>}

      {hasEvents && (
        <>
          {hasHeroFeatured ? (
            <>
              <HeroCarousel
                asset={blueprint.asset}
                events={heroFeaturedEvents}
                hasFeaturedEvents={hasFeaturedEvents}
              />
              {hasFeaturedEvents && (
                <FeaturedEvents blueprint={blueprint} events={featuredEvents} />
              )}
            </>
          ) : (
            <HeroSection blueprint={blueprint} />
          )}
          <GeneralEvents blueprint={blueprint} events={events} />
        </>
      )}
    </div>
  );
};

AdEvents.propTypes = {
  props: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  adEvents: PropTypes.shape({
    getAllEvents: PropTypes.func.isRequired,
    getEventsSubCategories: PropTypes.func.isRequired,
    getEventsBlueprint: PropTypes.func.isRequired,
  }).isRequired,
};

export default inject('adEvents')(AdEvents);
